import { render, staticRenderFns } from "./AppV3SettingsCollapse.vue?vue&type=template&id=685a63c6"
import script from "./AppV3SettingsCollapse.vue?vue&type=script&lang=js"
export * from "./AppV3SettingsCollapse.vue?vue&type=script&lang=js"
import style0 from "./AppV3SettingsCollapse.vue?vue&type=style&index=0&id=685a63c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports